/**
 * Webroot URL for folder ./web/
 * including trailing slash
 */
export const BASEURL: string = (window as any).BASEURL;

/**
 * Website home of current language
 * including trailing slash
 */
export const SITEURL: string = (window as any).SITEURL;

export const CRAFT_TRANSLATIONS: Record<string, string> = (window as any)
  .CRAFT_TRANSLATIONS;

export const CRAFT_LANGUAGE: string = (window as any).CRAFT_LANGUAGE;

export const CRAFT_SITE_HANDLE: string = (window as any).CRAFT_SITE_HANDLE;

export const ALGOLIA_CONFIG: {
  appId: string;
  searchKey: string;
  indexName: string;
} = (window as any).ALGOLIA_CONFIG;

export const GOOGLE_MAPS_CONFIG: {
  apiKey: string;
  mapId: string;
} = (window as any).GOOGLE_MAPS_CONFIG;
